/**
 * Container.js
 * Flexbox Container
 *
 * @class   Container
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import StylePropable from 'mixins/js/StylePropable.js';

export default React.createClass({

	mixins: [StylePropable],

	propTypes: {
		flexDirection: React.PropTypes.string, // row | row-reverse | column | column-reverse
		flexWrap: React.PropTypes.string, // nowrap | wrap | wrap-reverse
		alignItems: React.PropTypes.string, // flex-start | flex-end | center | baseline | stretch
		justifyContent: React.PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around']),
		alignContent: React.PropTypes.string, // flex-start | flex-end | center | space-between | space-around | stretch
		padded: React.PropTypes.bool,
		margin: React.PropTypes.bool,
		overflowX: React.PropTypes.oneOf(['visible', 'hidden', 'scroll', 'auto', 'initial', 'inherit']),
		overflowY: React.PropTypes.oneOf(['visible', 'hidden', 'scroll', 'auto', 'initial', 'inherit']),
		name: React.PropTypes.string,
		onScroll: React.PropTypes.func,
		height: React.PropTypes.string

	},

	getDefaultProps() {
		return {
			className: '',
			flexDirection: 'row',
			flexWrap: 'wrap',
			alignItems: 'stretch',
			justifyContent: 'flex-start',
			alignContent: 'stretch',
			onScroll: function() {}
		};
	},

	render() {

		let styles = this.mergeAndPrefix({
			maxWidth: '100%',
			boxSizing: 'border-box',
			flexDirection: this.props.flexDirection,
			flexWrap: this.props.flexWrap,
			alignItems: this.props.alignItems,
			justifyContent: this.props.justifyContent,
			alignContent: this.props.alignContent,
			overflowX: this.props.overflowX || 'initial',
            overflowY: this.props.overflowY || 'initial',
            height: this.props.height || 'auto',
		});

		let classes = ClassNames(this.props.className, {
			'lui-flexbox-container': true,
			'lui-padded': this.props.padded,
			'lui-margin': this.props.margin
		});

		return (
			<div className={classes} style={styles} name={this.props.name} onScroll={this.props.onScroll}>{this.props.children}</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/flexbox/Container.js
 **/